import styled from 'styled-components';

export const CardWrapper = styled.div`
  background: #ffffff;
  border-radius: 14px;
  padding: 16px;
  margin: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const Title = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
`;

export const TariffName = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #d81b60;
  margin-top: 4px;
`;

export const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #f5f5f5;
`;

export const PriceText = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #333;
`;

export const ActiveDate = styled.span`
  font-size: 11px;
  color: #666;
`;

export const FeatureList = styled.ul`
  margin: 0 0 16px 0;
  padding-left: 18px;
  font-size: 12px;
  color: #555;
  line-height: 1.6;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 8px;
`;
